import { yupResolver } from '@hookform/resolvers/yup';
import { DeepPartial, UnpackNestedValue, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { errorsInput } from 'src/consts';
import * as Yup from 'yup';

type ClientColisNumberAndDescriptionForm<T> = {
  defaultValues: UnpackNestedValue<DeepPartial<T>>;
};

export const useClientColisNumberAndDescriptionForm = <T>({
  defaultValues,
}: ClientColisNumberAndDescriptionForm<T>) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    colisNumber: Yup.number()
      .moreThan(0, t(errorsInput.moreThen, { number: 0 }))
      .required(errorsInput.required),
    description: Yup.string()
      .test('max-length-string', t(errorsInput.maxStringLength), (text) => {
        if (!text) {
          return true;
        }

        if (text.length > 300) {
          return false;
        }
        return true;
      })
      .required(errorsInput.required),
  });

  const formOptions = { resolver: yupResolver(validationSchema), defaultValues };

  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm<T>(formOptions);

  return {
    handleSubmit,
    control,
    errors,
    watch,
  };
};
